import { useState, useEffect } from 'react';
import api from '../api';
import toast from 'react-hot-toast';
import PasswordInput, { isPasswordValid } from '../components/PasswordInput';

const EMPTY = { name: '', email: '', password: '', receive_reports: true, is_active: true };

export default function ClientUsers() {
  const [users,   setUsers]   = useState([]);
  const [modal,   setModal]   = useState(false);
  const [form,    setForm]    = useState(EMPTY);
  const [editId,  setEditId]  = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => { loadData(); }, []);

  async function loadData() {
    try {
      const res = await api.get('/subusers');
      setUsers(res.data);
    } catch { toast.error('Klaida kraunant vartotojus'); }
  }

  function openCreate() {
    setEditId(null);
    setForm(EMPTY);
    setModal(true);
  }

  function openEdit(u) {
    setEditId(u.id);
    setForm({ ...u, password: '' });
    setModal(true);
  }

  async function handleSave(e) {
    e.preventDefault();
    setLoading(true);
    try {
      if (editId) {
        await api.put(`/subusers/${editId}`, form);
        toast.success('Vartotojas atnaujintas');
      } else {
        await api.post('/subusers', form);
        toast.success('Vartotojas sukurtas');
      }
      setModal(false);
      loadData();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Klaida');
    } finally { setLoading(false); }
  }

  async function handleDelete(id, name) {
    if (!window.confirm(`Ištrinti vartotoją "${name}"?`)) return;
    try {
      await api.delete(`/subusers/${id}`);
      toast.success('Vartotojas ištrintas');
      loadData();
    } catch { toast.error('Klaida trinant'); }
  }

  return (
    <div>
      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <div className="page-title">Paskyros vartotojai</div>
          <div className="page-subtitle">Pridėkite vartotojus, kurie gali prisijungti ir gauti ataskaitas</div>
        </div>
        <button className="btn btn-primary" onClick={openCreate}>+ Naujas vartotojas</button>
      </div>

      {/* Info baneris */}
      <div className="card" style={{ marginBottom: 24, background: 'rgba(59,130,246,0.08)', border: '1px solid rgba(59,130,246,0.2)' }}>
        <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
          <span style={{ fontSize: 20 }}>ℹ️</span>
          <div style={{ fontSize: 13, color: 'var(--text-muted)', lineHeight: 1.6 }}>
            <strong style={{ color: 'var(--text)' }}>Papildomi vartotojai</strong> gali prisijungti prie portalo ir peržiūrėti jūsų srauto duomenis bei ataskaitas.<br />
            Jei įjungta parinktis <strong style={{ color: 'var(--text)' }}>"Gauti ataskaitas"</strong> – jie automatiškai gaus ataskaitas el. paštu kartu su pagrindiniu klientu.
          </div>
        </div>
      </div>

      <div className="card" style={{ padding: 0 }}>
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Vardas</th>
                <th>El. paštas</th>
                <th>Gauti ataskaitas</th>
                <th>Būsena</th>
                <th>Sukurtas</th>
                <th>Veiksmai</th>
              </tr>
            </thead>
            <tbody>
              {users.map(u => (
                <tr key={u.id}>
                  <td style={{ fontWeight: 600 }}>{u.name}</td>
                  <td>{u.email}</td>
                  <td>
                    {u.receive_reports
                      ? <span className="badge badge-success">✅ Taip</span>
                      : <span className="badge badge-danger">⛔ Ne</span>}
                  </td>
                  <td>
                    <div className="cam-status">
                      <div className={`cam-dot ${u.is_active ? 'online' : 'offline'}`} />
                      {u.is_active ? 'Aktyvus' : 'Neaktyvus'}
                    </div>
                  </td>
                  <td style={{ fontSize: 12, color: 'var(--text-muted)' }}>
                    {new Date(u.created_at).toLocaleDateString('lt-LT')}
                  </td>
                  <td>
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button className="btn btn-sm btn-secondary" onClick={() => openEdit(u)}>✏️ Redaguoti</button>
                      <button className="btn btn-sm btn-danger"    onClick={() => handleDelete(u.id, u.name)}>🗑️</button>
                    </div>
                  </td>
                </tr>
              ))}
              {!users.length && (
                <tr>
                  <td colSpan={6} style={{ textAlign: 'center', color: 'var(--text-muted)', padding: 40 }}>
                    Dar nėra papildomų vartotojų. Paspauskite "+ Naujas vartotojas".
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {modal && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setModal(false)}>
          <div className="modal">
            <div className="modal-header">
              <div className="modal-title">{editId ? 'Redaguoti vartotoją' : 'Naujas vartotojas'}</div>
              <button className="modal-close" onClick={() => setModal(false)}>✕</button>
            </div>
            <form onSubmit={handleSave}>
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Vardas, pavardė *</label>
                  <input className="form-input" value={form.name}
                    onChange={e => setForm({...form, name: e.target.value})} required />
                </div>
                <div className="form-group">
                  <label className="form-label">El. paštas *</label>
                  <input className="form-input" type="email" value={form.email}
                    onChange={e => setForm({...form, email: e.target.value})} required />
                </div>
              </div>

              <div className="form-group">
                <PasswordInput
                  label={editId ? 'Slaptažodis (tuščia = nekeisti)' : 'Slaptažodis *'}
                  value={form.password}
                  onChange={e => setForm({...form, password: e.target.value})}
                  required={!editId}
                  showStrength={!!form.password}
                />
              </div>

              <div className="divider" />

              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', padding: '12px 16px', background: 'var(--card)', borderRadius: 8, border: '1px solid var(--border)' }}>
                  <input type="checkbox" checked={form.receive_reports}
                    onChange={e => setForm({...form, receive_reports: e.target.checked})}
                    style={{ width: 16, height: 16 }} />
                  <div>
                    <div style={{ fontWeight: 600, fontSize: 13 }}>📧 Gauti automatines ataskaitas</div>
                    <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>Ataskaitos bus siunčiamos kartu su pagrindiniu klientu</div>
                  </div>
                </label>

                {editId && (
                  <label style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', padding: '12px 16px', background: 'var(--card)', borderRadius: 8, border: '1px solid var(--border)' }}>
                    <input type="checkbox" checked={form.is_active}
                      onChange={e => setForm({...form, is_active: e.target.checked})}
                      style={{ width: 16, height: 16 }} />
                    <div>
                      <div style={{ fontWeight: 600, fontSize: 13 }}>✅ Vartotojas aktyvus</div>
                      <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>Neaktyvus vartotojas negali prisijungti</div>
                    </div>
                  </label>
                )}
              </div>

              <div className="divider" />
              <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                <button type="button" className="btn btn-secondary" onClick={() => setModal(false)}>Atšaukti</button>
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? <span className="loading-spinner" /> : editId ? 'Išsaugoti' : 'Sukurti'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
